export default __webpack_public_path__ + "static/media/hht2_ani_18.a868ae88.png";